import React, { Component } from 'react';
import * as mat from 'material-ui';
import Logo from '../images/Logoaa.jpg'
import './style.css'
import FaSignIn from 'react-icons/lib/fa/sign-in'
import FaUser from 'react-icons/lib/fa/user'
import { browserHistory } from 'react-router';
// import { UserLogOut } from '../../../actions/adminAction'
// import { connect } from 'react-redux';
// import { MyMage } from '../../../actions/questionsAction';
// import { UserSharedData, GetAllQuizs } from '../../../actions/ShareQuiz';
// import { AllQuiz } from '../../../actions/quizAction'
// import { adminDetailEdit } from '../../../actions/adminAction'

const styles = {
    logo: {
        width: 90,
        height: 45,
        marginLeft: '24%',
    },
}
class HOMENAV extends Component {
    LogIn() {
        browserHistory.push("/")
    }
    SignUp() {
        browserHistory.push("/sign-up")
    }
    render() {
        return (
            <div>
                <div>
                    <mat.AppBar
                        iconElementLeft={
                            <img style={styles.logo} src={Logo} alt='Logo' />
                        }
                        iconElementRight={
                            <div style={{ marginTop: '3%' }}>
                                <mat.RaisedButton
                                    onClick={this.SignUp.bind(this)}
                                    label='Sign Up'
                                    labelStyle={{ color: '#000000' }}
                                    icon={<FaUser style={{ color: '#000000', fontSize: 18, marginTop: -3 }} />}
                                />
                                &nbsp;
                                &nbsp;
                                <mat.RaisedButton
                                    onClick={this.LogIn.bind(this)}
                                    label='Login'
                                    labelStyle={{ color: '#000000' }}
                                    icon={<FaSignIn style={{ color: '#000000', fontSize: 18, marginTop: -3 }} />}
                                />
                            </div>
                        }
                        style={{ backgroundColor: '#2196f3' }}
                        zDepth={1}
                    />
                </div>
                <div>
                    {this.props.children}
                </div>
            </div>
        )
    }
}
export default HOMENAV;


// WEBPACK FOOTER //
// ./src/component/navBar/navbar.jsx